import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import copilotIcon from "../../assets/img/copilotIcon.svg";
import MinimizeIcon from "@mui/icons-material/Minimize";
import CropSquareIcon from "@mui/icons-material/CropSquare";

interface HeaderProps {
  onClose: () => void;
  isMinimized: boolean;
  onToggleMinimized: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  onClose,
  isMinimized,
  onToggleMinimized,
}) => {
  return (
    <Box
      id="copilot-header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        color: "white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <img
          id="copilot-header-icon"
          src={copilotIcon}
          alt="Copilot Icon"
          width="24"
          height="24"
          style={{ display: "block" }}
        />
        <Typography id="copilot-header-title" variant="h2">
          Copilot
        </Typography>
      </Box>

      <Box>
        <IconButton onClick={onToggleMinimized} size="small" sx={{ mr: 1 }}>
          {isMinimized ? <CropSquareIcon /> : <MinimizeIcon />}
        </IconButton>
        <IconButton id="copilot-close-button" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
